<template>
  <a-layout>
    <a-layout-content style="padding: 20px; min-height: calc(100vh - 64px)">
      <a-row :gutter="16">
        <!-- 左侧区域 (4列) -->
        <a-col :span="9">
          <div class="left-panel">
            <div class="search-container">
              <div class="search-header">
                <h3 class="search-title">{{ $t('dashboard.outbound.orderInquiry') }}</h3>
              </div>
              <div class="search-content">
                <a-input-search
                    v-model="searchValue"
                    :placeholder="$t('dashboard.outbound.placeholderSearchValue')"
                    :enter-button="$t('antd.table.search')"
                    @search="handleSearch"
                    @keyup.enter="handleSearch"
                    class="search-input"
                />
                <a-button class="clear-button" @click="handleClear">{{ $t('antd.table.clear') }}</a-button>
              </div>
              <div class="search-tips">
                <a-alert
                    :message="$t('dashboard.outbound.orderInquiryPrompt')"
                    :description="$t('dashboard.outbound.placeholderPrompt')"
                    type="info"
                    show-icon
                />
              </div>
            </div>

            <a-list
                class="order-list"
                :data-source="filteredOrders"
                :loading="loading"
                item-layout="horizontal"
            >
              <a-list-item
                  slot="renderItem"
                  slot-scope="item"
                  :class="{ 'selected-item': isSelected(item.barCodeNo),'payment-processing': item.payStatus == 1 }"
                  style="position: relative"
              >
                <!-- 添加水印 -->
                <div v-if="item.payStatus == 1" class="payment-watermark">支付进行中</div>
                <a-list-item-meta>
                  <div slot="title">
                    <a-checkbox
                        :checked="isSelected(item.barCodeNo)"
                        @change="e => handleSelectOrder(e.target.checked, item)"
                        :disabled="item.payStatus == 1"
                    >
                      {{ item.barCodeNo }}
                    </a-checkbox>
                  </div>
                  <template slot="description">
                    <span>{{ $t('dashboard.order.amount') }}: {{
                        item.amount
                      }} | {{ $t('dashboard.order.orderStatus') }}: {{
                        getStatusText(item.orderStatus)
                      }} | {{ $t('dashboard.order.isPayment') }}：</span>
                    <span :style="{ color: getPayStatusColor(item.isPayment) }">
                      {{ getPayStatusText(item.isPayment) }}
                    </span>
                    <!--                    <span v-if="item.payStatus == 1">-->
                    <!--                      | 结算状态：-->
                    <!--                      <span :style="{ color: getPayStatusColor(item.payStatus) }">{{ getCurrentPayStatusText(item.payStatus) }}</span>-->
                    <!--                    </span>-->
                  </template>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
        </a-col>

        <!-- 右侧区域 (6列) -->
        <a-col :span="15">
          <div class="right-panel">
            <a-card :title="title" :bordered="false">
              <template v-if="selectedOrders.length > 0">
                <div class="selected-count">
                  <span>{{ $t('dashboard.outbound.selectMsg') }} {{
                      selectedOrders.length
                    }} {{ $t('dashboard.outbound.selectUnit') }}</span>
                  <a-button type="link" @click="handleClearSelection">{{ $t('dashboard.outbound.clearSelection') }}
                  </a-button>
                </div>
                <a-collapse v-model="activeCollapseKeys" accordion>
                  <a-collapse-panel
                      v-for="order in selectedOrders"
                      :key="order.barCodeNo"
                  >
                    <template slot="header">
                      <span>{{ $t('dashboard.order.barCodeNo') }} : {{ order.barCodeNo }}</span>
                      <span :style="{ color: getPayStatusColor(order.isPayment), marginLeft: '10px' }">
                        {{ getPayStatusText(order.isPayment) }}
                      </span>
                    </template>
                    <a-descriptions :column="2" bordered>
                      <a-descriptions-item :label="$t('dashboard.outbound.orderAmount')">{{
                          order.amount
                        }}
                      </a-descriptions-item>
                      <a-descriptions-item :label="$t('dashboard.order.orderStatus')">
                        {{ getStatusText(order.orderStatus) }}
                      </a-descriptions-item>
                      <a-descriptions-item :label="$t('dashboard.outbound.customerName')">{{
                          order.toCustLinkman
                        }}
                      </a-descriptions-item>
                      <a-descriptions-item :label="$t('dashboard.outbound.contactNumber')">{{
                          order.toCustTel
                        }}
                      </a-descriptions-item>
                      <a-descriptions-item :label="$t('dashboard.outbound.passportNumber')">{{
                          order.toCustIdCardNo
                        }}
                      </a-descriptions-item>
                      <a-descriptions-item :label="$t('dashboard.outbound.deliveryAddress')" :span="2">
                        {{ order.toCustAddress }}
                      </a-descriptions-item>
                    </a-descriptions>
                    <div style="margin-top: 16px; text-align: right">
                      <a-button type="danger" @click="handleRemoveOrder(order.barCodeNo)">
                        {{ $t('dashboard.outbound.deselect') }}
                      </a-button>
                    </div>
                  </a-collapse-panel>
                </a-collapse>

                <div class="points-section">
                  <a-divider/>
                  <a-alert
                      :message="$t('dashboard.outbound.availablePoints')"
                      :description="`${$t('dashboard.outbound.pointDesc1')} ${availablePoints} ${$t('dashboard.outbound.pointDesc2')} ${offsetAmountUz} ${$t('dashboard.outbound.unit')}`"
                      type="info"
                      show-icon
                  />
                  <div style="margin-top: 16px">
                    <a-checkbox
                        v-model="usePoints"
                        @change="changUsePoints"
                        :disabled="!hasUnpaidOrders || availablePoints < 100"
                    >{{ $t('dashboard.outbound.usePointsDeduct') }}
                    </a-checkbox>
                    <span style="margin-left: 16px">{{ $t('dashboard.outbound.deductionAmount') }} : <span
                        style="color: rgb(245, 34, 45);font-size: 15px">{{
                        deductAmount
                      }}</span> {{ $t('dashboard.outbound.unit') }}</span>
                    <div v-if="!hasUnpaidOrders" style="color: #f5222d; margin-top: 4px;">
                      {{ $t('dashboard.outbound.prompt1') }}
                    </div>
                    <div v-else-if="availablePoints < 100" style="color: #f5222d; margin-top: 4px;">
                      {{ $t('dashboard.outbound.prompt2') }}
                    </div>
                  </div>
                </div>

                <div class="total-section">
                  <a-divider/>
                  <h3>{{ $t('dashboard.outbound.totalOrderAmount') }} : {{ totalAmount.toFixed(2) }} UZS</h3>
                  <div v-if="usePoints && pointsToUse > 0" style="margin: 10px 0">
                    <h4>{{ $t('dashboard.outbound.pointsDeduction') }} :
                      <span style="color: rgb(245, 34, 45);font-size: 15px">-{{ deductAmount }}</span>
                      {{ $t('dashboard.outbound.unit') }}
                      ({{ $t('dashboard.outbound.use') }}
                      <span style="color: rgb(245, 34, 45);font-size: 15px">{{ pointsToUse }} </span>
                      {{ $t('dashboard.outbound.points') }})</h4>
                  </div>
                  <h3 style="color: #f5222d" v-if="unpaidOrders.length > 0">{{ $t('dashboard.outbound.payableAmount') }}
                    : {{ remainingAmount.toFixed(2) }}
                    UZS</h3>
                  <h3 v-if="paidOrders.length > 0 && unpaidOrders.length == 0">
                    {{ $t('dashboard.outbound.orderAllPaid') }}</h3>

                  <div class="payment-bubble" v-if="showPaymentBubble">
                    <div class="bubble-content" style="background-color: #f8f9fa">
                      <div class="bubble-arrow"></div>
                      <div class="payment-methods">
                        <a-button
                            v-for="method in paymentMethods"
                            :key="method.value"
                            @click="handlePaymentMethodSelect(method.value)"
                            class="payment-method-btn"
                        >
                          <img :src="method.icon" class="payment-icon" v-if="method.icon"/>
                          {{ method.label }}
                        </a-button>
                      </div>
                    </div>
                  </div>
                  <a-button
                      type="primary"
                      size="large"
                      @click="togglePaymentBubble"
                      :loading="outboundLoading"
                      class="outbound-btn"
                  >
                    {{ $t('dashboard.outbound.confirmOutbound') }}
                  </a-button>
                </div>
              </template>

              <template v-else>
                <a-empty :description="$t('dashboard.outbound.prompt3')"/>
              </template>
            </a-card>
          </div>
        </a-col>
      </a-row>

      <!-- 支付确认弹窗 -->
      <a-modal
          :visible="paymentModalVisible"
          @ok="handleSubmit"
          @cancel="handlePaymentCancel"
          :confirmLoading="paymentConfirmLoading"
          :width="600"
          :okText="$t('dashboard.outbound.confirmPayment')"
          :cancelText="$t('dashboard.outbound.cancel')"
          :maskClosable="false"
          class="payment-confirm-modal"
      >
        <template slot="title">
          <div style="color: #000000d9; font-size: 18px;">
            {{ selectedPaymentMethodName }}-{{ $t('dashboard.outbound.prompt4') }}
          </div>
        </template>
        <div class="payment-amount">
          <a-icon type="dollar" style="color: #52c41a; font-size: 24px; margin-right: 12px;"/>
          <h3 style="margin: 0; color: #333; font-weight: 500;">
            {{ $t('dashboard.outbound.payableAmount') }}: <span
              style="color: #1890ff; font-size: 24px;">{{ remainingAmount.toFixed(2) }}</span>
            {{ $t('dashboard.outbound.unit') }}
          </h3>
        </div>

        <a-divider style="margin: 16px 0;"/>

        <a-form-model
            :model="paymentForm"
            layout="horizontal"
            class="payment-form"
            :rules="formRules"
            ref="paymentFormRef"
        >
          <a-form-model-item
              :label="$t('dashboard.outbound.transactionId')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 18 }"
              class="form-item left-align-form-item"
              prop="transactionId"
          >
            <a-input
                v-model="paymentForm.transactionId"
                :placeholder="$t('dashboard.outbound.placeholderTransactionId')"
                allowClear
                size="large"
            >
              <a-icon slot="prefix" type="transaction" style="color: rgba(0, 0, 0, 0.25)"/>
            </a-input>
          </a-form-model-item>

          <a-form-model-item
              :label="$t('dashboard.outbound.actualReceivedAmount')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 18 }"
              class="form-item left-align-form-item"
              prop="actualReceivedAmount"
          >
            <a-input-number
                v-model="paymentForm.actualReceivedAmount"
                :placeholder="$t('dashboard.outbound.placeholderActualReceivedAmount')"
                style="width: 100%"
                :min="0"
                :precision="2"
                size="large"
            >
              <a-icon slot="prefix" type="money-collect" style="color: rgba(0, 0, 0, 0.25)"/>
            </a-input-number>
          </a-form-model-item>
        </a-form-model>

        <div class="payment-tips">
          <a-alert
              :message="$t('dashboard.outbound.prompt5')"
              type="warning"
              show-icon
              banner
              class="warning-alert"
          />
        </div>
      </a-modal>


      <!-- Payme支付模态框 -->
      <a-modal
          :visible="paymeModalVisible"
          :footer="null"
          :width="450"
          @cancel="handlePaymeCancel"
          :maskClosable="false"
          :closable="!paymeProcessing"
          class="payme-modal"
      >
        <div class="payme-header">
          <img
              src="https://cdn.payme.uz/logo/payme_color.svg"
              alt="Payme Logo"
              class="payme-logo"
          />
          <h3 class="payme-title">{{ $t('dashboard.outbound.paymePay') }}</h3>
        </div>

        <div class="payme-content">
          <!-- 加载状态 -->
          <div v-if="paymeLoading" class="payme-loading">
            <a-spin size="large" :tip="$t('dashboard.outbound.prompt6')">
              <a-icon slot="indicator" type="loading" style="font-size: 24px" spin/>
            </a-spin>
          </div>

          <!-- 处理中状态 -->
          <div v-if="paymeProcessing" class="payme-processing">
            <div class="processing-content">
              <a-spin size="large" :tip="$t('dashboard.outbound.prompt7')">
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin/>
              </a-spin>
              <div class="amount-info">
                <p class="processing-amount">
                  {{ $t('dashboard.outbound.paymentAmount') }}: <span class="amount">{{
                    paymeAmount.toFixed(2)
                  }} {{ $t('dashboard.outbound.unit') }}</span>
                </p>
                <p class="order-id">{{ $t('dashboard.outbound.orderNumber') }}: {{ paymeOrderId }}</p>
              </div>
            </div>
          </div>

          <!-- 支付二维码状态 -->
          <div v-show="!paymeLoading && !paymeProcessing" class="payme-ready">
            <div class="amount-display">
              <span class="amount-label">{{ $t('dashboard.outbound.paymentAmount') }}:</span>
              <span class="amount-value">{{ paymeAmount.toFixed(2) }} {{ $t('dashboard.outbound.unit') }}</span>
            </div>

            <!-- 二维码容器 - 添加二维码加载状态 -->
            <div class="qr-code-wrapper">
              <div v-if="qrLoading" class="qr-loading">
                <a-spin :tip="$t('dashboard.outbound.prompt8')" size="large">
                  <a-icon slot="indicator" type="loading" style="font-size: 24px" spin/>
                </a-spin>
              </div>
              <div id="qr-container" class="qr-code-container" v-show="!qrLoading"></div>
            </div>

            <div class="payme-instructions">
              <p>
                <a-icon type="scan"/>
                {{ $t('dashboard.outbound.prompt9') }}
              </p>
              <p class="expire-time">{{ $t('dashboard.outbound.prompt10') }}</p>
            </div>
          </div>
        </div>

        <!-- 不再需要隐藏的Payme表单 -->
      </a-modal>


    </a-layout-content>
  </a-layout>
</template>

<script>
import {dictGet, getOutboundInfo} from 'api/app'
import {
  getCustomerAvailablePoints,
  operateOrderOutbound,
  preparePayment,
  checkPaymentStatus,
  doPayMeOutBound,
  doCancelPayment
} from 'api/app'
import QRCode from 'qrcode'

export default {
  data() {
    return {
      title: this.$t('dashboard.order.darcodeInfor'),
      searchValue: '',
      filterStatus: 'all',
      loading: false,
      pointsLoading: false,
      outboundLoading: false,
      orderList: [],
      selectedOrders: [],
      activeCollapseKeys: [],
      availablePoints: 0,
      offsetAmountUz: 0,
      exchangeRate: 0,
      usePoints: false,
      pointsToUse: 0,
      deductAmount: 0,
      remainingAmount: 0,
      readyPayAmount: 0,
      pointsRate: 100, // 1美元等于100积分
      dictEum: {},
      // 新增支付相关数据
      showPaymentBubble: false,
      paymentModalVisible: false,
      paymentConfirmLoading: false,
      selectedPaymentMethod: null,
      selectedPaymentMethodName: '',
      paymentMethods: [
        {
          label: this.$t('dashboard.outbound.cash'),
          value: 1,
          icon: require('assets/img/png/cash.png') // 假设你的现金图标路径
        },
        {
          label: this.$t('dashboard.outbound.payme'),
          value: 2,
          icon: require('assets/img/svg/payme.svg') // 假设你的微信图标路径
        },
        {
          label: this.$t('dashboard.outbound.weChat'),
          value: 3,
          icon: require('assets/img/png/wechat.png') // 假设你的微信图标路径
        },
        {
          label: this.$t('dashboard.outbound.alipay'),
          value: 4,
          icon: require('assets/img/png/alipay.png') // 假设你的支付宝图标路径
        },
        {
          label: this.$t('dashboard.outbound.pos'),
          value: 5,
          icon: require('assets/img/png/pos.png') // 假设你的POS图标路径
        },
        {
          label: this.$t('dashboard.outbound.uzumpal'),
          value: 6,
          icon: require('assets/img/png/pay.png') // 假设你的POS图标路径
        }
      ],
      qrLoading: false, // 新增二维码加载状态轮询
      paymentForm: {
        transactionId: '',
        actualReceivedAmount: null
      },
      formRules: {
        transactionId: [
          {required: true, message: this.$t('dashboard.outbound.placeholderTransactionId'), trigger: 'blur'},
          {min: 6, message: '交易号长度至少6位', trigger: 'blur'}
        ],
        actualReceivedAmount: [
          {required: true, message: this.$t('dashboard.outbound.placeholderActualReceivedAmount'), trigger: 'blur'},
          {validator: this.validateAmount, trigger: 'blur'}
        ]
      },

      paymeMerchantId: '680f2eae773c5114506ff509',
      paymeModalVisible: false,
      paymeLoading: false,
      paymeProcessing: false,
      paymeOrderId: null,
      paymePollingInterval: null
    };
  },
  computed: {
    filteredOrders() {
      let result = this.orderList;
      if (this.filterStatus !== 'all') {
        result = result.filter(item => item.orderStatus.toString() == this.filterStatus);
      }
      return result
    },
    currentCustomerNo() {
      return this.selectedOrders.length > 0 ? this.selectedOrders[0].customerNo : null;
    },
    paidOrders() {
      return this.selectedOrders.filter(item => item.isPayment == 1);
    },
    unpaidOrders() {
      return this.selectedOrders.filter(item => item.isPayment == 0);
    },
    totalAmount() {
      return this.unpaidOrders.reduce((sum, order) => sum + (parseFloat(order.amount) || 0), 0);
    },
    hasUnpaidOrders() {
      return this.selectedOrders.some(order => order.isPayment == 0);
    },
    paymeAmount() {
      return Math.round(this.readyPayAmount / 100);
    },
    getStatusText() {
      return function (value) {
        return this.dictEum[value] ? this.dictEum[value] : ""
      }
    },
  },
  watch: {
    usePoints(newVal) {
      if (newVal) {
        this.calculateTotal();
      } else {
        this.resetPointsCalculation();
      }
    },
    selectedOrders: {
      deep: true,
      handler() {
        this.calculateTotal();
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  async created() {
    let dictEum = await dictGet({
      dictType: ""
    })
    this.dictEum = dictEum.data.order_status
  },
  methods: {
    // 处理Payme支付
    async handlePaymePayment() {
      this.paymeModalVisible = true;
      this.paymeLoading = true;
      this.paymeProcessing = false;

      try {
        // 准备订单信息
        const paymentParams = {
          barCodeNos: this.unpaidOrders.map(order => order.barCodeNo),
          paidBarCodeNos: this.paidOrders.map(order => order.barCodeNo),
          usedPoints: this.usePoints ? this.pointsToUse : 0
        };

        // 调用API准备支付
        const response = await preparePayment(paymentParams);

        if (response.code == 200) {
          this.paymeOrderId = response.data.serialNum;
          this.readyPayAmount = response.data.payableAmount;
          await this.$nextTick();
          this.loadPaymeScript();
        } else {
          // throw new Error(response.msg || this.$t('dashboard.outbound.errorPrompt1'));
          this.$message.error(response.msg || this.$t('dashboard.outbound.errorPrompt1'));
          this.paymeModalVisible = false;
        }
      } catch (error) {
        console.error('Payme支付初始化失败:', error);
        this.$message.error(this.$t('dashboard.outbound.errorPrompt2') + error.message);
        this.paymeModalVisible = false;
      } finally {
        this.paymeLoading = false;
      }
    },

    // 加载Payme脚本
    loadPaymeScript() {
      // 直接调用初始化二维码方法，不再需要加载外部脚本
      this.initPaymeQR();
    },

    // 初始化Payme二维码
    async initPaymeQR() {
      // 确保容器存在
      const qrContainer = document.getElementById('qr-container');
      if (!qrContainer) {
        console.error('二维码容器未找到');
        this.$message.error(this.$t('dashboard.outbound.errorPrompt4'));
        this.paymeModalVisible = false;
        return;
      }

      try {
        // 显示二维码加载状态
        this.qrLoading = true;

        // 清除旧的二维码
        qrContainer.innerHTML = '';

        // 构建base64编码的URL
        const paymentData = {
          m: this.paymeMerchantId,
          'ac.labelNo': this.paymeOrderId,
          a: this.readyPayAmount
        };

        // 将数据转换为字符串并进行base64编码
        const dataString = Object.entries(paymentData)
            .map(([key, value]) => `${key}=${value}`)
            .join(';');
        const base64Data = btoa(dataString);
        const paymeUrl = `https://checkout.paycom.uz/${base64Data}`;
        console.log('paymeUrl:' + paymeUrl)

        // 模拟延迟，展示加载效果
        await new Promise(resolve => setTimeout(resolve, 500));

        // 使用QRCode库生成二维码
        const canvas = document.createElement('canvas');
        await QRCode.toCanvas(canvas, paymeUrl, {
          width: 300,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });

        // 将canvas添加到容器中
        qrContainer.appendChild(canvas);

        // 隐藏加载状态
        this.qrLoading = false;
        // 开始轮询支付状态
        this.startPaymentPolling();
      } catch (error) {
        console.error('初始化二维码失败:', error);
        this.qrLoading = false;
        this.$message.error(this.$t('dashboard.outbound.errorPrompt7') + error.message);
        this.paymeModalVisible = false;
      }
    },

    // 开始轮询支付状态
    startPaymentPolling() {
      let attempts = 0;
      const maxAttempts = 900; // 最大尝试次数(约30分钟)
      const interval = 2000;  // 轮询间隔2秒

      this.paymePollingInterval = setInterval(async () => {
        try {
          const res = await checkPaymentStatus({
            serialNum: this.paymeOrderId
          });

          if (res.code == 200) {
            if (res.status == 'PAID') {
              clearInterval(this.paymePollingInterval);
              this.$message.success(this.$t('dashboard.outbound.paymentSuccess'));
              this.handlePaymeOutBound();
              this.paymeModalVisible = false;
            } else if (res.status == 'FAILED') {
              clearInterval(this.paymePollingInterval);
              this.$message.error(this.$t('dashboard.outbound.errorPrompt8'));
              this.paymeModalVisible = false;
            }
          }

          attempts++;
          if (attempts >= maxAttempts) {
            clearInterval(this.paymePollingInterval);
            this.$message.warning(this.$t('dashboard.outbound.errorPrompt9'));
            this.paymeProcessing = false;
          }
        } catch (error) {
          console.error('支付状态检查失败:', error);
          attempts++;
          if (attempts >= maxAttempts) {
            clearInterval(this.paymePollingInterval);
            this.paymeProcessing = false;
          }
        }
      }, interval);
    },

    // 取消Payme支付
    handlePaymeCancel() {
      if (this.paymePollingInterval) {
        clearInterval(this.paymePollingInterval);
      }
      this.paymeModalVisible = false;
      this.paymeLoading = false;
      this.paymeProcessing = false;
      doCancelPayment({
        serialNum: this.paymeOrderId
      }).then(res => {
        if (res.code == 200) {
          // this.$message.info(this.$t('dashboard.outbound.cancelPaySuccess'));
          this.$notification.warning({
            message: 'warning', // 标题
            description: this.$t('dashboard.outbound.cancelPaySuccess'), // 详细描述
            duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
            placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
            style: {
              width: '400px', // 自定义宽度
              top: '100px', // 调整位置
              right: '50px', // 调整位置
              background: '#fffbe6',
              border: '1px solid #ffe58f', // 边框颜色
              borderRadius: '4px',
              boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
            },
          });
        } else {
          // this.$message.error(this.$t('dashboard.outbound.cancelPayFailed'));
          this.$notification.error({
            message: 'error', // 标题
            description: res.msg || this.$t('dashboard.outbound.cancelPayFailed'), // 详细描述
            duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
            placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
            style: {
              width: '400px', // 自定义宽度
              top: '100px', // 调整位置
              right: '50px', // 调整位置
              background: '#fff2f0', // 背景色
              border: '1px solid #ffccc7', // 边框色
              borderRadius: '4px',
              boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
            },
          });
        }
      }).catch(error => {
        console.log(error);
        this.$message.error(this.$t('dashboard.outbound.cancelPayFailed'));
      })
    },

    // payme支付出库
    handlePaymeOutBound() {
      if (this.paymePollingInterval) {
        clearInterval(this.paymePollingInterval);
      }
      this.paymeModalVisible = false;
      this.paymeLoading = false;
      this.paymeProcessing = false;
      doPayMeOutBound({
        serialNum: this.paymeOrderId,
        operateSource: 'pc'
      }).then(res => {
        if (res.code == 200) {
          // this.$message.info(this.$t('dashboard.outbound.outboundSuccess'));
          this.$notification.success({
            message: 'success', // 标题
            description: this.$t('dashboard.outbound.outboundSuccess'), // 详细描述
            duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
            placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
            style: {
              width: '400px', // 自定义宽度
              top: '100px', // 调整位置
              right: '50px', // 调整位置
              background: '#f6ffed',  // 背景色
              border: '1px solid #b7eb8f',  // 边框
              borderRadius: '4px',
              boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
            },
          });
          this.selectedOrders = [];
          this.orderList = []
          this.searchValue = ''
          this.resetPointsData();
          this.resetPaymentForm();
        } else {
          // this.$message.error(res.msg || this.$t('dashboard.outbound.errorPrompt13'));
          this.$notification.error({
            message: 'error', // 标题
            description: res.msg || this.$t('dashboard.outbound.errorPrompt13'), // 详细描述
            duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
            placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
            style: {
              width: '400px', // 自定义宽度
              top: '100px', // 调整位置
              right: '50px', // 调整位置
              background: '#fff2f0', // 背景色
              border: '1px solid #ffccc7', // 边框色
              borderRadius: '4px',
              boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
            },
          });
        }
      }).catch(error => {
        console.log(error);
        // this.$message.error(this.$t('dashboard.outbound.errorPrompt13'));
        this.$notification.error({
          message: 'error', // 标题
          description: this.$t('dashboard.outbound.errorPrompt13'), // 详细描述
          duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
          placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
          style: {
            width: '400px', // 自定义宽度
            top: '100px', // 调整位置
            right: '50px', // 调整位置
            background: '#fff2f0', // 背景色
            border: '1px solid #ffccc7', // 边框色
            borderRadius: '4px',
            boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
          },
        });
      })
    },

    validateAmount(rule, value, callback) {
      if (value == null || value == undefined || value == '') {
        callback(new Error(this.$t('dashboard.outbound.placeholderActualReceivedAmount')));
      } else if (value <= 0) {
        callback(new Error(this.$t('dashboard.outbound.prompt11')));
      } else {
        callback();
      }
    },
    handleSubmit() {
      this.$refs.paymentFormRef.validate(valid => {
        if (valid) {
          this.handlePaymentConfirm(); // 验证通过后执行原确认逻辑
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    calculateTotal() {
      this.$nextTick(() => {
        try {
          const unpaidTotal = this.totalAmount;

          let pointsToUse = 0;
          let deductAmount = 0;
          let remainingAmount = unpaidTotal;

          if (this.usePoints && this.hasUnpaidOrders && this.availablePoints > 100) {
            const maxDeductAmount = this.availablePoints / this.pointsRate;
            const maxDeductAmountUZ = maxDeductAmount * this.exchangeRate;
            deductAmount = Math.min(unpaidTotal, maxDeductAmountUZ);

            pointsToUse = Math.min(
                Math.floor(deductAmount / this.exchangeRate * this.pointsRate),
                this.availablePoints
            );

            remainingAmount = Math.max(0, unpaidTotal - deductAmount);
          }

          this.pointsToUse = pointsToUse;
          this.deductAmount = parseFloat(deductAmount.toFixed(2));
          this.remainingAmount = parseFloat(remainingAmount.toFixed(2));
        } catch (error) {
          console.error('计算错误:', error);
          this.pointsToUse = 0;
          this.deductAmount = 0;
          this.remainingAmount = this.totalAmount;
        }
      });
    },
    changUsePoints() {
      this.calculateTotal()
    },
    resetPointsCalculation() {
      this.pointsToUse = 0;
      this.deductAmount = 0;
      this.calculateTotal();
    },

    isSelected(barCodeNo) {
      return this.selectedOrders.some(item => item.barCodeNo == barCodeNo);
    },

    // getStatusText(status) {
    //   const statusMap = {
    //     0: '待入库',
    //     1: '已入库',
    //     2: '已签收',
    //     3: '异常订单'
    //   };
    //   return statusMap[status] || '未知状态';
    // },
    getPayStatusText(status) {
      const statusMap = {
        0: '未收款',
        1: '已收款',
      };
      return statusMap[status] || '未知状态';
    },
    // getCurrentPayStatusText(status) {
    //   const statusMap = {
    //     0: '',
    //     1: '等待支付中',
    //   };
    //   return statusMap[status] || '未知状态';
    // },
    getPayStatusColor(status) {
      return status == 1 ? '#52c41a' : '#f5222d';
    },

    async loadDefaultData() {
      if (this.searchValue == '' || this.searchValue == null) {
        this.$message.error(this.$t('dashboard.outbound.placeholderSearchValue'));
        return
      }
      this.orderList = []
      this.selectedOrders = []
      this.loading = true;
      try {
        const response = await getOutboundInfo({
          orderNo: this.searchValue
        });
        this.orderList = response.data || [];
        if (this.orderList.length < 1) {
          this.$message.success(this.$t('dashboard.outbound.prompt12'));
        }
      } catch (error) {
        console.error('获取订单数据失败:', error);
        this.$message.error(this.$t('dashboard.outbound.errorPrompt10'));
      } finally {
        this.loading = false;
      }
    },

    async loadCustomerPoints() {
      if (!this.currentCustomerNo) {
        this.availablePoints = 0;
        this.offsetAmountUz = 0;
        this.pointsToUse = 0;
        this.usePoints = false;
        return;
      }

      this.pointsLoading = true;
      try {
        const response = await getCustomerAvailablePoints({
          customerNo: this.currentCustomerNo
        });
        this.availablePoints = response.data?.points || 0;
        this.offsetAmountUz = response.data?.offsetAmountUz || 0;
        this.exchangeRate = response.data?.strExchangeRate || 0;
        this.calculateTotal();
      } catch (error) {
        console.error('获取积分数据失败:', error);
        this.$message.error(this.$t('dashboard.outbound.errorPrompt11'))
        this.availablePoints = 0;
      } finally {
        this.pointsLoading = false;
      }
    },

    handleSearch() {
      this.loadDefaultData();
    },

    handleClear() {
      this.searchValue = '';
      this.filterStatus = 'all';
      this.orderList = [];
      this.selectedOrders = [];
      this.resetPointsData();
    },

    resetPointsData() {
      debugger
      this.availablePoints = 0;
      this.offsetAmountUz = 0;
      this.usePoints = false;
      this.resetPointsCalculation();
    },

    async handleSelectOrder(checked, order) {
      if (checked) {
        if (this.selectedOrders.length > 0) {
          const firstOrder = this.selectedOrders[0];
          if (firstOrder.toCustIdCardNo !== order.toCustIdCardNo) {
            this.$message.warning(this.$t('dashboard.outbound.errorPrompt12'));
            return;
          }
        }
        if (order.payStatus == 1 || order.payStatus == 2) {
          this.$message.warning("该订单已经处于等待支付状态，请选择其他订单");
          return;
        }
        if (!this.isSelected(order.barCodeNo)) {
          this.selectedOrders.push(order);
          this.activeCollapseKeys = [order.barCodeNo];
          await this.loadCustomerPoints();
        }
      } else {
        this.selectedOrders = this.selectedOrders.filter(item => item.barCodeNo !== order.barCodeNo);
        if (this.selectedOrders.length == 0) {
          this.resetPointsData();
        } else {
          await this.loadCustomerPoints();
        }
      }

      if (this.selectedOrders.length > 0) {
        const allPaid = this.selectedOrders.every(order => order.isPayment == 1);
        if (this.usePoints && allPaid) {
          this.usePoints = !allPaid;
        }
      }

      this.calculateTotal();
    },

    async handleRemoveOrder(barCodeNo) {
      const newSelected = this.selectedOrders.filter(item => item.barCodeNo !== barCodeNo);
      this.selectedOrders = newSelected;
      if (newSelected.length == 0) {
        this.resetPointsData();
      } else {
        await this.loadCustomerPoints();
      }
      this.calculateTotal();
    },

    handleClearSelection() {
      this.selectedOrders = [];
      this.resetPointsData();
    },

    // 切换支付气泡显示
    togglePaymentBubble() {
      if (this.selectedOrders.length == 0) {
        this.$message.warning(this.$t('dashboard.outbound.prompt13'));
        return;
      }

      const firstIdCardNo = this.selectedOrders[0].toCustIdCardNo;
      const hasDifferentUser = this.selectedOrders.some(order => order.toCustIdCardNo !== firstIdCardNo);
      const hasUnPaidOrder = this.selectedOrders.some(order => order.isPayment == 0);

      if (hasDifferentUser) {
        this.$message.warning(this.$t('dashboard.outbound.prompt14'));
        return;
      }

      if (!hasUnPaidOrder) {
        console.log('均是已支付订单，直接出库')
        this.handleOutbound()
        return;
      }

      this.showPaymentBubble = !this.showPaymentBubble;
    },

    // 点击外部关闭气泡
    handleClickOutside(e) {
      const bubble = this.$el.querySelector('.payment-bubble');
      const button = this.$el.querySelector('.outbound-btn');

      if (this.showPaymentBubble && bubble && button &&
          !bubble.contains(e.target) && !button.contains(e.target)) {
        this.showPaymentBubble = false;
      }
    },

    // 修改handlePaymentMethodSelect方法
    async handlePaymentMethodSelect(method) {
      this.selectedPaymentMethod = method;
      this.showPaymentBubble = false;
      const selectedMethod = this.paymentMethods.find(m => m.value == method);
      this.selectedPaymentMethodName = selectedMethod ? selectedMethod.label : this.$t('dashboard.outbound.unknownPaymentMethod');

      if (method == 2) { // Payme
        await this.handlePaymePayment();
      } else {
        this.paymentModalVisible = true;
        this.paymentForm.actualReceivedAmount = this.remainingAmount;
      }
    },

    // 处理支付确认
    async handlePaymentConfirm() {
      if (!this.paymentForm.transactionId) {
        this.$message.warning(this.$t('dashboard.outbound.placeholderTransactionId'));
        return;
      }

      if (!this.paymentForm.actualReceivedAmount || this.paymentForm.actualReceivedAmount <= 0) {
        this.$message.warning(this.$t('dashboard.outbound.placeholderActualReceivedAmount'));
        return;
      }
      // if (this.paymentForm.actualReceivedAmount > this.remainingAmount) {
      //   this.$message.warning(this.$t('dashboard.outbound.prompt15'));
      //   return;
      // }

      this.paymentConfirmLoading = true;
      try {
        await this.handleOutbound();
        this.paymentModalVisible = false;
        this.resetPaymentForm();
      } finally {
        this.paymentConfirmLoading = false;
      }
    },

    // 处理支付取消
    handlePaymentCancel() {
      // 重置表单验证状态
      this.$refs.paymentFormRef && this.$refs.paymentFormRef.clearValidate();
      this.paymentModalVisible = false;
      this.resetPaymentForm();
    },

    // 重置支付表单
    resetPaymentForm() {
      debugger
      this.paymentForm = {
        transactionId: '',
        actualReceivedAmount: null
      };
      this.selectedPaymentMethodName = ''
    },

    // 确认出库方法
    async handleOutbound() {
      const paidNos = this.paidOrders.map(item => item.barCodeNo);
      const unpaidNos = this.unpaidOrders.map(item => item.barCodeNo);

      this.outboundLoading = true;
      try {
        const params = {
          paidNos: paidNos,
          unpaidNos: unpaidNos,
          usePoints: this.usePoints ? 1 : 0,
          pointsUsed: this.pointsToUse,
          paymentSource: this.selectedPaymentMethod,
          transactionId: this.paymentForm.transactionId,
          actualReceivedAmount: this.paymentForm.actualReceivedAmount,
          operateSource: 'pc',
        };

        const response = await operateOrderOutbound(params);

        if (response.code == 200) {
          // this.$message.success(response.msg || this.$t('dashboard.outbound.outboundSuccess'));
          this.$notification.success({
            message: 'success', // 标题
            description: this.$t('dashboard.outbound.outboundSuccess'), // 详细描述
            duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
            placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
            style: {
              width: '400px', // 自定义宽度
              top: '100px', // 调整位置
              right: '50px', // 调整位置
              background: '#f6ffed',  // 背景色
              border: '1px solid #b7eb8f',  // 边框
              borderRadius: '4px',
              boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
            },
          });
          this.selectedOrders = [];
          this.resetPointsData();
          this.resetPaymentForm();
          if (this.orderList.length > paidNos.length + unpaidNos.length) {
            this.loadDefaultData();
          } else {
            this.orderList = []
            this.searchValue = ''
          }
        } else {
          // this.$message.error(response.msg || this.$t('dashboard.outbound.errorPrompt13'));
          this.$notification.error({
            message: 'error', // 标题
            description: response.msg || this.$t('dashboard.outbound.errorPrompt13'), // 详细描述
            duration: 5, // 5秒后自动关闭（0 表示不自动关闭）
            placement: 'topRight', // 位置：topLeft | topRight | bottomLeft | bottomRight
            style: {
              width: '400px', // 自定义宽度
              top: '100px', // 调整位置
              right: '50px', // 调整位置
              background: '#fff2f0', // 背景色
              border: '1px solid #ffccc7', // 边框色
              borderRadius: '4px',
              boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
            },
          });
        }
      } catch (error) {
        console.error('出库请求异常:', error);
        if (error.response) {
          const errorMsg = error.response.data?.message ||
              error.response.statusText ||
              `请求失败 (${error.response.status})`;
          this.$message.error(errorMsg);
        } else if (error.request) {
          this.$message.error(this.$t('dashboard.outbound.errorPrompt14'));
        } else {
          this.$message.error(error.message || this.$t('dashboard.outbound.errorPrompt13'));
        }
      } finally {
        this.outboundLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.left-panel, .right-panel {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: calc(100vh - 120px);
  overflow-y: auto;
}

.search-container {
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.search-header {
  margin-bottom: 16px;
}

.search-title {
  font-size: 16px;
  color: #1f1f1f;
  margin: 0;
  font-weight: 500;
}

.search-content {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.search-input {
  flex: 1;
}

.clear-button {
  width: 72px;
  height: 32px;
}

.search-tips {
  margin-top: 8px;
}

@media (max-width: 576px) {
  .search-content {
    flex-direction: column;
  }

  .clear-button {
    width: 100%;
  }
}

.order-list {
  height: calc(100% - 108px);
  overflow-y: auto;
}

.points-section, .total-section {
  margin-top: 20px;
}

.total-section {
  text-align: right;
  position: relative;
}

.total-section h3 {
  margin-bottom: 20px;
  font-size: 18px;
  color: #1890ff;
}

.selected-count {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.ant-collapse {
  margin-bottom: 16px;
}

.ant-collapse-item {
  margin-bottom: 8px;
}

.ant-list-item-meta {
  margin-left: 15px;
}

@media (max-width: 992px) {
  .left-panel, .right-panel {
    height: auto;
    max-height: 50vh;
  }
}

.selected-item {
  background: #e6f7ff;
}

.green-text {
  color: #52c41a;
}

.red-text {
  color: #f5222d;
}

/* 支付气泡样式 */
.payment-bubble {
  position: absolute;
  bottom: 28%;
  right: 0;
  margin-bottom: 10px;
  z-index: 10;
}

.bubble-content {
  position: relative;
  background: #f8f9fa;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 10px;
}

.bubble-arrow {
  position: absolute;
  bottom: -6px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #fff;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));
}

.payment-methods {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.payment-method-btn {
  width: 100%;
  margin: 4px 0;
  white-space: nowrap;
}

.outbound-btn {
  position: relative;
  margin-top: 20px;
}

.payment-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
}

.payment-confirm-modal >>> .ant-modal-header {
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(to right, #fafafa, #ffffff);
}

.payment-confirm-modal >>> .ant-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.payment-amount {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #fafafa;
  border-radius: 4px;
  margin-bottom: 16px;
}

.payment-form {
  padding: 0 16px;
}

.form-item {
  margin-bottom: 20px;
}

.left-align-form-item >>> .ant-form-item-label {
  text-align: left !important;
  padding-right: 8px;
}

.left-align-form-item >>> .ant-form-item-control {
  max-width: 100%;
}

.payment-tips {
  margin-top: 24px;
}

.warning-alert {
  border: 1px solid #ffccc7;
  background-color: #fff2f0;
}

.warning-alert >>> .ant-alert-message {
  color: #ff4d4f;
  font-weight: 500;
}

.warning-alert >>> .ant-alert-icon {
  color: #ff4d4f;
}

/* Payme模态框样式 */
.payme-modal {
  border-radius: 8px;
  overflow: hidden;
}

.payme-modal >>> .ant-modal-content {
  border-radius: 8px;
}

.payme-modal >>> .ant-modal-header {
  border-bottom: none;
  padding: 0;
}

.payme-modal >>> .ant-modal-body {
  padding: 0;
}

/* 头部样式 */
.payme-header {
  background: linear-gradient(135deg, #1890ff, #096dd9);
  padding: 20px;
  text-align: center;
  color: white;
  position: relative;
}

.payme-logo {
  height: 30px;
  margin-bottom: 10px;
}

.payme-title {
  color: white;
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}

/* 内容区域 */
.payme-content {
  padding: 24px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 加载状态 */
.payme-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
}

/* 处理中状态 */
.payme-processing {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.processing-content {
  text-align: center;
}

.amount-info {
  margin-top: 20px;
}

.processing-amount {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}

.processing-amount .amount {
  font-weight: bold;
  color: #1890ff;
}

.order-id {
  font-size: 14px;
  color: #666;
}

/* 支付就绪状态 */
.payme-ready {
  width: 100%;
  text-align: center;
}

.amount-display {
  background: #f7f7f7;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: inline-block;
}

.amount-label {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}

.amount-value {
  font-size: 18px;
  font-weight: bold;
  color: #1890ff;
}

/* 新增二维码加载样式 */
.qr-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1;
  border-radius: 8px;
}

/* 确保二维码容器始终有适当的高度 */
.qr-code-wrapper {
  width: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  background: #f7f7f7;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  position: relative; /* 为loading添加定位 */
}

/* 二维码容器样式 */
.qr-code-container {
  width: 100%;
  display: flex;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.3s ease;
}

/* 隐藏时的样式 */
.qr-code-container[v-show="false"] {
  opacity: 0;
  height: 0;
  overflow: hidden;
}

/* 支付说明 */
.payme-instructions {
  margin-top: 20px;
  color: #666;
  font-size: 14px;
}

.payme-instructions p {
  margin: 5px 0;
}

.expire-time {
  color: #f5222d;
  font-size: 13px;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .payme-modal {
    width: 90% !important;
    max-width: 350px;
  }

  .payme-header {
    padding: 15px;
  }

  .payme-logo {
    height: 25px;
  }

  .payme-content {
    padding: 15px;
  }

  .qr-code-wrapper {
    min-height: 250px;
    padding: 15px;
  }
}

/* 水印样式 */
/* 支付进行中的订单样式 */
.payment-processing {
  position: relative;
  background-color: #f5f5f5 !important; /* 灰色背景 */
  cursor: not-allowed !important; /* 禁用鼠标样式 */
  opacity: 0.8; /* 半透明效果 */
}

/* 水印样式 */
.payment-watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-30deg);
  font-size: 20px;
  font-weight: bold;
  color: #ed2538 !important; /* 红色水印 */
  pointer-events: none;
  z-index: 1;
  white-space: nowrap;
  opacity: 0.6; /* 半透明效果 */
}

/* 禁用复选框 */
.payment-processing .ant-checkbox-wrapper {
  color: rgba(0, 0, 0, 0.25) !important;
}

.payment-processing .ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
</style>
